import React, { useState, useEffect } from 'react';
import backendApi from "./BackendApi";


const BackgroundImage = ( props ) => {

  const src = props.src;
  const children = props.children;

  const [backgroundUrl, setBackgroundUrl] = useState('');

  useEffect(() => {
    const fetchBackground = async () => {
      try {
        //const response = await fetch('https://www.domino-design.it/domino/api/ui-img/image/'+src );
        const response = await backendApi.get("/api/ui-img/image/"+src,{ responseType: "blob" });
        if (response.status ==200) {
          const data = await response.data;
          const imageUrl = URL.createObjectURL(data);
          setBackgroundUrl(imageUrl);
        } else {
          // Handle the error if the request fails
          console.log('Error on response:', response);
        }
      } catch (error) {
        console.log('Error:', error);
      }
    };

    fetchBackground();
    // Clean up the URL object when the component is unmounted
    return () => URL.revokeObjectURL(backgroundUrl);
  }, []);

  return (
    <div style={{ backgroundImage: `url(${backgroundUrl})` }}>
     {children}
    </div>
  );
};

export default BackgroundImage;
